import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, DateRangePicker, Input, SelectPicker } from "rsuite";
import { APi } from "../../Api";
import Filter from "../../Components/Common/Filter";
import Responsive from "../../Components/Responsive";
import ResumeCard from "../../Components/ResumeCard";
import { dateTypes, serviceTypes } from "../../Constants/types";
import format_number from "../../Helpers/number_formatter";

const CheckoutSummary = () => {
  const [data, setData] = useState([]);
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [checkouts, setCheckouts] = useState([]);
  const [checkoutsData, setCheckoutsData] = useState([]);

  const [filterModel, setFilterModel] = useState({
    service: 0,
    clientId: 0,
    representativeId: 0,
    date: null,
    dateType: 0,
  });

  const fetchClients = (query = "", forFilter = true) => {
    if (!query || query.length > 2) {
      APi.createAPIEndpoint(APi.ENDPOINTS.Client, { q: query }, "/autocomplete")
        .customGet()
        .then((res) => {
          if (forFilter) setClients(res.data);
        });
    }
  };

  const fetchData = () => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Transaction + "/summary", filterModel)
      .fetchAll()
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {});
  };

  const fetchCheckouts = () => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Checkout, {}, "/autocomplete")
      .customGet()
      .then((res) =>
        setCheckouts(res.data.map((el) => ({ value: el.id, label: el.name })))
      );
  };

  const fetchCheckoutDetails = (checkoutId) => {
    const model = { ...filterModel, checkoutId };
    delete model.service;
    setLoading(true);

    APi.createAPIEndpoint(APi.ENDPOINTS.Transaction + "/summaryDetails", model)
      .fetchAll()
      .then((res) => {
        setDetails(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const fetchInitialCheckoutsData = () => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Checkout)
      .customGet()
      .then((res) => setCheckoutsData(res.data.data));
  };

  useEffect(() => {
    fetchData();
    fetchCheckouts();
    fetchInitialCheckoutsData();
  }, [filterModel]);

  const handleDateSelect = (dateType) => {
    const today = new Date(moment().format("yyyy-MM-DD"));
    const dateFrom =
      dateType === 6
        ? today
        : dateType === 3
        ? moment().startOf("month").format("yyyy-MM-DD")
        : dateType === 4
        ? moment().subtract(1, "months").startOf("month").format("yyyy-MM-DD")
        : dateType === 5
        ? moment().startOf("year").format("yyyy-MM-DD")
        : null;

    const dateTo =
      dateType === 6
        ? moment().add(1, "d").format("yyyy-MM-DD")
        : dateType === 3
        ? today
        : dateType === 4
        ? moment().subtract(1, "months").endOf("month").format("yyyy-MM-DD")
        : null;

    setFilterModel((prev) => ({
      ...prev,
      dateType,
      date: [7, 1].includes(dateType) ? today : null,
      dateFrom,
      dateTo,
    }));
  };

  const handleCheckoutClick = (ch) => {
    const isCurrentCheckoutSelected = filterModel.checkoutId === ch.checkoutId;

    if (isCurrentCheckoutSelected) {
      setFilterModel((prev) => ({ ...prev, checkoutId: null }));
      setDetails([]);
    } else {
      setDetails([]);
      setFilterModel((prev) => ({
        ...prev,
        checkoutId: ch.checkoutId,
      }));
      fetchCheckoutDetails(ch.checkoutId);
    }
  };

  return (
    <div>
      <Filter search={fetchData}>
        <Responsive m={6} l={2} xl={2} className="p-5">
          <label>Dates: </label>
          <SelectPicker
            data={dateTypes}
            block
            noSearch
            value={filterModel.dateType}
            onSelect={(dateType) => handleDateSelect(dateType)}
          />
        </Responsive>
        {filterModel.dateType === 7 && (
          <Responsive m={6} l={2.6} xl={2.6} className="p-5">
            <label>Date: </label>
            <Input
              type="date"
              value={filterModel.date}
              onChange={(date) => setFilterModel((prev) => ({ ...prev, date }))}
            />
          </Responsive>
        )}
        {filterModel.dateType == 6 && (
          <Responsive m={6} l={2.6} xl={2.6} className="p-5">
            <label>Plage du temps: </label>
            <DateRangePicker
              block
              value={[filterModel.dateFrom, filterModel.dateTo]}
              onChange={(vs) => {
                setFilterModel((prev) => ({
                  ...prev,
                  dateFrom: vs[0],
                  dateTo: vs[1],
                }));
              }}
            />
          </Responsive>
        )}
        <Responsive m={6} l={2.4} xl={2.4} className="p-5">
          <label>Client: </label>
          <SelectPicker
            onSearch={(q) => fetchClients(q)}
            data={[{ label: "Tout", value: null }].concat(
              clients.map((c) => {
                return { label: c.name, value: c.id };
              })
            )}
            block
            noSearch
            value={filterModel.clientId}
            onSelect={(clientId) => {
              setFilterModel((prev) => {
                return { ...prev, clientId };
              });
            }}
          />
        </Responsive>
        <Responsive m={6} l={2.4} xl={2.4} className="p-5">
          <label>Service: </label>
          <SelectPicker
            searchable={false}
            data={[{ label: "Tout", value: 0 }].concat(serviceTypes)}
            block
            noSearch
            value={filterModel.service}
            onSelect={(service) => {
              setFilterModel((prev) => {
                return { ...prev, service };
              });
            }}
          />
        </Responsive>
      </Filter>
      <div>
        {data.map((ch) => (
          <Responsive l={6} xl={6} className="p-10" key={ch.checkoutId}>
            <div
              style={{
                padding: "8px",
                border: "1px dashed #121212",
                borderRadius: "10px",
                background: "#fff",
              }}
            >
              <h6 style={{ color: "#090909" }}>
                {checkouts
                  .find((c) => c.value === ch.checkoutId)
                  ?.label.toUpperCase() || ""}
              </h6>
              <Responsive className="p-10" m={6} l={6} xl={6}>
                <ResumeCard
                  text="Total"
                  color="0,169,141"
                  amount={ch.totalCount}
                  notAmount
                />
              </Responsive>
              <Responsive className="p-10" m={6} l={6} xl={6}>
                <ResumeCard
                  text="Total Crédit"
                  color="245,195,35"
                  amount={ch.totalCredit}
                />
              </Responsive>
              <Responsive className="p-10" m={6} l={6} xl={6}>
                <ResumeCard
                  text="Total Débit"
                  color="229,57,53"
                  amount={ch.totalDebit}
                />
              </Responsive>
              <Responsive className="p-10" m={6} l={6} xl={6}>
                <ResumeCard
                  text="Balance"
                  color="60,16,83"
                  amount={ch.balance}
                />
              </Responsive>
              <div>
                <Button
                  onClick={() => handleCheckoutClick(ch)}
                  appearance="ghost"
                  color="violet"
                  loading={loading && filterModel.checkoutId === ch.checkoutId}
                >
                  Détails
                </Button>
              </div>
              {filterModel.checkoutId === ch.checkoutId &&
                details.length > 0 && (
                  <div
                    style={{
                      background: "#f5f5f5",
                      borderRadius: "8px",
                      padding: "6px",
                      marginTop: "8px",
                    }}
                  >
                    {details.map((el, idx) => (
                      <div
                        key={idx}
                        style={{
                          background: "#fff",
                          borderRadius: "5px",
                          padding: "10px",
                          margin: "5px",
                          display: "inline-block",
                        }}
                      >
                        <h6
                          style={{
                            borderBottom: "1px solid #eee",
                            color: "#4c67c2",
                          }}
                        >
                          {serviceTypes.find((s) => s.value === el.service)
                            ?.label || "Autres"}
                        </h6>
                        <div>
                          Total Débit : <b>{format_number(el.totalDebit)}</b>
                        </div>
                        <div>
                          Total Crédit : <b>{format_number(el.totalCredit)}</b>
                        </div>
                        <div
                          style={{
                            marginTop: "5px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          Balance :{" "}
                          <b
                            style={{
                              background:
                                el.totalDebit - el.totalCredit >= 0
                                  ? "rgba(0,169,141,0.1)"
                                  : "rgba(182,25,85,0.1)",
                              padding: "5px",
                              borderRadius: "5px",
                            }}
                          >
                            {format_number(el.totalDebit - el.totalCredit)}
                          </b>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
            </div>
          </Responsive>
        ))}
      </div>
    </div>
  );
};

export default CheckoutSummary;
